// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import calendarReducer from './slices/calendar';
import menuReducer from './slices/menu';
import patientListReducer from './slices/patientList';
import providerListReducer from './slices/providersList';
import patientReducer from './slices/patient';
import providerReducer from './slices/provider';
import enrollmentReducer from './slices/enrollment';
import careSessionListReducer from './slices/careSessionList';
import carePlanReducer from './slices/carePlan';
import documentsReducer from './slices/documents';
import accountReducer from './slices/account';
import vitalsDataReducer from './slices/vitalsData';
import vitalsAlertsReducer from './slices/vitalsAlerts';
import taskReducer from './slices/task';
import usersReducer from './slices/users';
import clinicSettingsReducer from './slices/clinicSettings';
import protocolsTemplateReducer from './slices/protocolsTemplate';
import protocolsInstanceReducer from './slices/protocolsInstance';
import customProgrammaticTaskReducer from './slices/customProgrammaticTask';
import treatmentPlanReducer from './slices/treatmentPlan';
import medicationReducer from './slices/medication';
import organizationDocumentsReducer from './slices/organizationDocuments';
import teamsReducer from './slices/teams';
import clinicsReducer from './slices/clinics';
import reportPatientListReducer from './slices/reportMedicationPdc';
import patientCriticalNotesReducer from './slices/patientCriticalNotes';
import medHXSubmissionManagementReducer from './slices/medHXSubmissionManagement';
import patientCareSuspensionReducer from './slices/patientCareSuspension';
import twilioOutboundCallReducer from './slices/twilioOutboundCall';
import callHistoryReducer from './slices/callHistory';
import officeLocationReducer from './slices/officeLocation';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    calendar: calendarReducer,
    menu: menuReducer,
    patientList: patientListReducer,
    providerList: providerListReducer,
    patient: patientReducer,
    provider: providerReducer,
    enrollment: enrollmentReducer,
    careSessionList: careSessionListReducer,
    carePlan: carePlanReducer,
    documents: documentsReducer,
    account: accountReducer,
    vitalsData: vitalsDataReducer,
    vitalsAlerts: vitalsAlertsReducer,
    task: taskReducer,
    users: usersReducer,
    clinicSettings: clinicSettingsReducer,
    protocolsTemplate: protocolsTemplateReducer,
    protocolsInstance: protocolsInstanceReducer,
    customProgrammaticTask: customProgrammaticTaskReducer,
    treatmentPlan: treatmentPlanReducer,
    medication: medicationReducer,
    organizationDocuments: organizationDocumentsReducer,
    teams: teamsReducer,
    clinics: clinicsReducer,
    reportPatientList: reportPatientListReducer,
    patientCriticalNotes: patientCriticalNotesReducer,
    medHXSubmissionManagement: medHXSubmissionManagementReducer,
    patientCareSuspension: patientCareSuspensionReducer,
    twilioOutboundCall: twilioOutboundCallReducer,
    callHistory: callHistoryReducer,
    officeLocation: officeLocationReducer
});

export default reducer;
